import React from "react";
import { createBrowserRouter, RouteObject } from "react-router-dom";
import AbSuspense from "./components/AbSuspense";
import SuperUserContainerOutlet from "./components/SuperUserContainerOutlet";
import IconExample from "./components/library/icons/IconExample";

const AppContent = React.lazy(() => import('./AppContent'))
const Callback = React.lazy(() => import('./routes/protected/Callback.Route'))
const AltinnCallback = React.lazy(() => import('./routes/protected/AltinnCallback.Route'))
const ProjectApiMigration = React.lazy(() => import('./components/admin/ProjectApiMigration'))
const RedirectGuid = React.lazy(() => import('./components/library/redirects/RedirectGuid'))

export const openRoutes = ["", "/", "admin"]
export const isOpenRoute = openRoutes.includes(window.location.pathname)
// console.log("location", location.pathname.split("/"), location)
const routes: RouteObject[] = [

  {
    path: "*",
    element: <AbSuspense children={<AppContent />} />
  },
  {
    path: "/authCallback",
    element: <AbSuspense children={<Callback />} />,
  },{
    path: "/altinn/authCallback",
    element: <AbSuspense children={<AltinnCallback />} />,
  },
  {
    path: "/adminarea/*",
    element: <AbSuspense children={<SuperUserContainerOutlet /> } />,
    children: [
      {
        path: "projectApiMigration",
        element: <AbSuspense children={<ProjectApiMigration /> }/>
      },
      {
        path: "iconExample",
        element: <AbSuspense children={<IconExample /> }/>
      }
    ]
  },
  {
    path: "/redirectGuid/:redirectGuid",
    element: <AbSuspense children={<RedirectGuid /> } />
  }
]
export const router = createBrowserRouter(routes);
